module.exports = __webpack_public_path__ + "static/media/profile-pic.5d01e0ee.jpg";